<template>
  <BlogPostLayout>
    <template #image>
      <BlogHeader
        :title="postData.title"
        :excerpt="postData.excerpt"
        :image="postData.image"
        :author="postData.author"
        :date="postData.date"
        :updatedAt="postData.updatedAt"
        :categories="postData.categories"
        :readTime="postData.readTime"
      />
    </template>
    <template #content>
      <article class="blog-content" lang="fr">
        <section class="intro">
          <p>
            Le terme <strong>Google Maps 360</strong> désigne souvent les
            <strong>photos 360°</strong> visibles sur votre fiche Google Maps —
            en pratique alimentées par <strong>Google Street View</strong>, dans
            la Recherche, Maps et l’<strong>application Street View</strong>.
          </p>
          <p>
            Ce guide explique où ce contenu apparaît, comment utiliser l’app
            Street View pour une capture simple, et quand passer par Travvir pour
            <a href="/blog/fr/publier-google-street-view"
              >publier un tour complet sur Street View</a
            >.
            <strong>Pour l’instant,</strong> Travvir publie via son compte éditeur
            Street View, pas le vôtre.
          </p>
        </section>

        <section>
          <h2>Où apparaît le contenu Maps 360 ?</h2>
          <ul>
            <li>Panneau Google Business dans la Recherche.</li>
            <li>Galerie photos et carte dans Google Maps.</li>
            <li>Application Street View (iOS et Android).</li>
          </ul>
        </section>

        <section>
          <h2>Option 1 — Application Street View (gratuite)</h2>
          <ol>
            <li>Télécharger l’app et se connecter au compte de la fiche.</li>
            <li>Icône appareil photo → capture guidée d’une sphère 360°.</li>
            <li>Vérifier l’épingle sur l’adresse et publier sur Maps.</li>
            <li>Attendre la validation Google (souvent 24–72 h).</li>
          </ol>
        </section>

        <section>
          <h2>Option 2 — Travvir (visite multi-pièces)</h2>
          <p>
            Capture smartphone, liaison des pièces, visite pour votre site web,
            puis publication sur Google via Partager → Google Street View.
            Travvir utilise son <strong>compte éditeur Street View</strong> — pas
            votre compte Google perso. Voir le
            <a href="/blog/fr/publier-google-street-view">tutoriel complet</a>.
          </p>
        </section>

        <section>
          <h2>Comparatif</h2>
          <table>
            <thead>
              <tr>
                <th></th>
                <th>App Street View</th>
                <th>Travvir</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Plusieurs pièces</td>
                <td>Scène par scène</td>
                <td>Tour relié</td>
              </tr>
              <tr>
                <td>Site web + hotspots</td>
                <td>Limité</td>
                <td>Oui</td>
              </tr>
              <tr>
                <td>Publication Maps</td>
                <td>Votre compte Google dans l’app Street View</td>
                <td>Depuis Travvir (compte éditeur Travvir)</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section>
          <h2>FAQ</h2>
          <p>
            <strong>Délai de validation ?</strong> En général 24 à 72 heures
            après envoi à Google.
          </p>
          <p>
            <strong>Avec Travvir :</strong> pas de compte Google perso à lier —
            publication via le compte éditeur Travvir. <strong>Avec l’app Street
            View :</strong> connectez-vous avec un compte propriétaire ou
            gestionnaire de la fiche Google Business.
          </p>
        </section>

        <section class="continue-reading">
          <h2>Continuer la lecture</h2>
          <ul>
            <li>
              <a href="/blog/fr/publier-google-street-view"
                >Publier sur Google Street View avec Travvir</a
              >
            </li>
            <li>
              <a href="/blog/fr/visite-virtuelle-google-business"
                >Visite virtuelle Google Business</a
              >
            </li>
          </ul>
        </section>

        <RelatedPosts
          :currentSlug="postData.slug"
          :currentCategories="postData.categories"
        />
      </article>
    </template>
  </BlogPostLayout>
</template>

<script setup>
import blogPostsData from "~/data/blogPosts.json";
const postData = blogPostsData.find(
  (p) => p.slug === "guide-google-maps-360",
);

useBlogSeo({
  title:
    "Google Maps 360 et app Street View : guide entreprise [2026] | Travvir",
  description:
    "Comprendre Google Maps 360 pour votre fiche, utiliser l’application Street View et publier une visite 360° complète avec Travvir.",
  keywords:
    "google maps 360, application street view, google street view, photos 360 google business",
  slug: "guide-google-maps-360",
  image: postData?.image,
  postData,
  lang: "fr",
});
</script>
